module.exports = __webpack_public_path__ + "static/media/fingerUpDown.69f79a89.png";